<!--<label>* ({{"mandatory_fields"|translate}})</label>-->
<form
	class="form-horizontal ng-pristine ng-valid"
	[formGroup]="OBJ_form_group">
	<ng-container
		*ngFor="let OBJ_field of ARR_form_fields;"
		tigDynamicField
		[OBJ_field_config]="OBJ_field"
		[OBJ_form_group]="OBJ_form_group">
	</ng-container>
</form>
<accordion *ngIf="BOO_development">
	<accordion-group [panelClass]="'panel-danger'">
		<div accordion-heading><i class="fa fa-angle-down"></i> Formularwerte</div>
		<pre>{{ARR_form_fields | json}}</pre>
	</accordion-group>
</accordion>